import { Link } from "react-router-dom";

export function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-slate-200 px-6 py-10 text-xs text-slate-500">
      <div className="mx-auto max-w-5xl">
        <div className="grid gap-8 sm:grid-cols-2 md:grid-cols-3">
          {/* Legal & Policies */}
          <div>
            <h3 className="mb-3 text-[11px] font-bold uppercase tracking-widest text-slate-700">Legal &amp; Policies</h3>
            <ul className="space-y-2">
              <li><Link to="/terms" data-testid="footer-terms-link" className="font-semibold text-slate-600 hover:text-brand-2">Terms and Conditions</Link></li>
              <li><Link to="/privacy" data-testid="footer-privacy-link" className="font-semibold text-slate-600 hover:text-brand-2">Privacy Policy</Link></li>
              <li><Link to="/subscription-policy" data-testid="footer-subscription-policy-link" className="font-semibold text-slate-600 hover:text-brand-2">Subscription Policy</Link></li>
            </ul>
          </div>

          {/* Support */}
          <div>
            <h3 className="mb-3 text-[11px] font-bold uppercase tracking-widest text-slate-700">Support</h3>
            <ul className="space-y-2">
              <li>
                <a href="mailto:support@progarages.co.uk" data-testid="footer-support-email" className="font-semibold text-slate-600 hover:text-brand-2">support@progarages.co.uk</a>
              </li>
            </ul>
          </div>

          {/* Company information */}
          <div className="leading-relaxed">
            <h3 className="mb-3 text-[11px] font-bold uppercase tracking-widest text-slate-700">Pro Garages</h3>
            <p>© 2026 Pro Garages. All rights reserved.</p>
            <p className="mt-2">BIS AUTO BODYWORKS LTD, trading as Pro Garages.</p>
            <p>Company number: 17193494.</p>
            <p className="mt-2">Registered office: Unit 7 Kartar Trading Estate, Shale Street, Bilston, WV14 0HF, United Kingdom.</p>
          </div>
        </div>

        <p className="mt-8 text-center text-slate-400">Built for UK independent garages</p>
      </div>
    </footer>
  );
}
